import { type ComponentPropsWithoutRef, type ReactElement } from 'react';
import { SvgClose } from '@/components/icons-eataly';
import { focusVisibleOutline } from '@/lib/focus-styles';
import { cn } from '@/lib/utils';

/** Shared close control styles (drawers, toasts, inline dismiss). Does not include layout/positioning. */
export const dismissCloseButtonClassName = cn(
    'flex shrink-0 cursor-pointer text-[var(--neutral-10)]',
    'rounded-sm shadow-none hover:bg-transparent hover:text-[var(--brown-30)]',
    focusVisibleOutline,
    'disabled:text-[var(--status-neutral-60)] disabled:hover:text-[var(--status-neutral-60)] disabled:opacity-100'
);

export type DismissCloseButtonProps = Omit<ComponentPropsWithoutRef<'button'>, 'children' | 'type'> & {
    /** Required for accessibility on icon-only control. */
    'aria-label': string;
};

/**
 * Icon-only close control for drawers, notifications, and overlays — uses {@link SvgClose}.
 */
export function DismissCloseButton({ className, ...props }: DismissCloseButtonProps): ReactElement {
    return (
        <button type="button" className={cn(dismissCloseButtonClassName, className)} {...props}>
            <SvgClose className="size-6" aria-hidden />
        </button>
    );
}
